module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alexander Fullerton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Alexander Fullerton was a bestselling author of British naval fiction, whose writing career spanned over fifty years. He served with distinction as gunnery and torpedo officer of HM Submarine Seadog during World War Two. He was a fluent Russian speaker, and after the war served in Germany as the Royal Navy liaison with the Red Army.")]), _c('P', [_vm._v("His first novel, Surface!, was written on the backs of old cargo manifests. It sold over 500,000 copies and needed five reprints in six weeks. Fullerton is perhaps best known though for his nine-volume Nicholas Everard series, which was translated into many languages, winning him fans all round the world. His fiftieth novel, Submariner, was published in 2008, the year of his death.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dq1OCU/images/cover-image.jpg?1702120376970",
      "alt": "This image is the cover for the book Flight to Mons"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Flight to Mons\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("An action-packed and authentic First World War thriller.")]), _c('p', [_vm._v("A young woman has vital information that could save millions of lives, and "), _c('b', [_vm._v("Charlie Holt")]), _vm._v(" is chosen to pilot a newly-built airship to evacuate her from France. ")]), _c('p', [_vm._v("In return for her intelligence he must guarantee the safety of her and her invalid mother. But retrieving two women from war-torn France is easier said than done.")]), _c('p', [_vm._v("Holt sets out with the help of a marine and an air mechanic, but when all his best laid plans go terribly wrong, he has to finish the mission alone. Only success against the odds can save his honour… ")]), _c('p', [_c('i', [_c('b', [_vm._v("Flight to Mons ")])]), _vm._v("is a gripping adventure packed with period and military detail, perfect for fans of Douglas Reeman and Philip McCutchan.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0